import { useEffect, useState } from 'react';

const LOAD_ERROR = 'Unable to load pickup sites. Please close this form and try again.';

export default function useSites({ backEndURL, token }, enabled = true) {
  const [state, setState] = useState({ sites: [], loading: false, error: '' });

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    const controller = new AbortController();

    async function loadSites() {
      setState({ sites: [], loading: true, error: '' });
      try {
        const response = await fetch(`${backEndURL}/sites`, {
          headers: { Authorization: `Bearer ${token}` },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(LOAD_ERROR);
        const json = await response.json();
        const sites = json?.data?.sites;
        if (!json?.success || !Array.isArray(sites) || sites.some(
          site => !site || typeof site._id !== 'string' || typeof site.name !== 'string'
        )) {
          throw new Error(LOAD_ERROR);
        }
        if (active) setState({ sites, loading: false, error: '' });
      } catch {
        if (active) setState({ sites: [], loading: false, error: LOAD_ERROR });
      }
    }

    loadSites();
    return () => {
      active = false;
      controller.abort();
    };
  }, [backEndURL, token, enabled]);

  return state;
}
